import { render, staticRenderFns } from "./cp22Edit.vue?vue&type=template&id=6107c92f"
import script from "./cp22Edit.vue?vue&type=script&lang=js"
export * from "./cp22Edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports